module.exports = __webpack_public_path__ + "static/assets/6e17469e7d979d6ed7006a21136680b0.svg";